import React from 'react'
import { async, fromJSX } from 'widgets-for-react'
import { FooterLayout } from './footerLayout'
import { FooterState, Links } from './footerState'

export const footerWidget = (showCookiebar: () => void) => (state: FooterState) =>
  async<Links>(state, links =>
    fromJSX(() => (
      <FooterLayout items={links} showCookiebar={showCookiebar} />
    ))
  )
